export default __webpack_public_path__ + "static/media/close.f61e4e1d.svg";